import { CanActivateFn, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { ProductAdminPageComponent } from './views/product-admin-page.component';
import { RuleAdminPageComponent } from './views/rule-admin-page.component';
import { PricingAdminPageComponent } from './views/pricing-admin-page.component';
import { UserProductConfigPageComponent } from './views/user-product-config-page.component';
import { KeycloakAuthService } from './core/auth/keycloak-auth.service';

const adminAuthGuard: CanActivateFn = async () => {
  const auth = inject(KeycloakAuthService);
  const active = await auth.ensureSession();
  if (active) {
    return true;
  }
  await auth.login();
  return false;
};

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'user/configure' },
  { path: 'admin/products', component: ProductAdminPageComponent, canActivate: [adminAuthGuard] },
  { path: 'admin/rules', component: RuleAdminPageComponent, canActivate: [adminAuthGuard] },
  { path: 'admin/pricing', component: PricingAdminPageComponent, canActivate: [adminAuthGuard] },
  { path: 'user/configure', component: UserProductConfigPageComponent },
  { path: '**', redirectTo: 'user/configure' }
];
